import * as Colors from './Colors';

export const DEVICE_TOKEN = 'device_token';

export const SMALL_FONT = 14;
export const NORMAL_FONT = 18;
export const LARGE_FONT = 22;

export const DefaultCalendarTheme = {
    monthTextColor: Colors.Black,
    textSectionTitleColor: Colors.Black,
    textSectionTitleDisabledColor: 'lightgray',
    selectedDayBackgroundColor: Colors.PrimaryColor,
    selectedDayTextColor: Colors.White,
    dayTextColor: 'gray',
    todayTextColor: 'white',
    todayBackgroundColor: 'rgba(0, 0, 255, 0.2)',
    textDisabledColor: '#d9e1e8',
    textMonthFontSize: 20,
    textMonthFontWeight: 'bold',
    textDayHeaderFontWeight: 'bold',
    textDayHeaderFontSize: 14,
};